import axios from 'axios';

export const publicClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
  maxContentLength: 100000000,
  maxBodyLength: 1000000000,
});

export const authClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'sr',
  },
});

// The AI engine is served by the API itself, at /api/ai - so its address is the API's own
// base plus /ai, with nothing extra to configure. REACT_APP_AI_ENGINE_URL stays supported as
// an override, for pointing at an engine running standalone on its own port.
// Same platform token; the engine decides by permission what to return. No auto-logout
// here: an engine error must not sign the admin out.
export const engineBaseURL =
  process.env.REACT_APP_AI_ENGINE_URL ||
  (process.env.REACT_APP_SERVER_URL
    ? `${process.env.REACT_APP_SERVER_URL.replace(/\/+$/, '')}/ai`
    : '');

export const engineClient = axios.create({
  baseURL: engineBaseURL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

engineClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

authClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

authClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.message || '';
    const errorStatus = error.response?.status;
    const requestUrl = error.config?.url || '';

    const isAuthRelatedError =
      // errorStatus === 401 ||
      // errorStatus === 403 ||
      errorStatus === 400 &&
      (errorMessage.toLowerCase().includes('invalidan token') ||
        errorMessage.toLowerCase().includes('token expired') ||
        errorMessage.toLowerCase().includes('invalid token') ||
        errorMessage.toLowerCase().includes('unauthorized'));

    const isRegistrationRequest = requestUrl.includes('/register');

    if (isAuthRelatedError && !isRegistrationRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      window.location.href = '/prijava';
    }

    return Promise.reject(error);
  }
);
